import React, { useEffect, useRef } from "react";

export const useWindowResize = (callback = () => {}, deps = []) => {
    const width = useRef(window.innerWidth);
    const height = useRef(window.innerHeight);

    useEffect(() => {
        const resizeHandler = () => {
            if (width.current !== window.innerWidth) {
                width.current = window.innerWidth;
                if (!deps.length || deps.includes('width')) {
                    callback({ width: width.current, height: height.current });
                }
            }
            if (height.current !== window.innerHeight) {
                height.current = window.innerHeight;
                if (!deps.length || deps.includes('height')) {
                    callback({ width: width.current, height: height.current });
                }
            }
        };
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler)
    }, []);

}